import Button from './form/button';

$(function () {
	let $addressButtonElement = $(".find_address_btn");
	let addressButton = new Button($addressButtonElement);

	$addressButtonElement.on('click', function () {
		var form = $(this).closest("form");
        let postCodeField = form.find('input[name="postCode"]');
        if (! postCodeField.length) {
            postCodeField = form.find('input[name="postalCode"]');
        }
		var postcode = postCodeField.val();
		var $select_add = form.find(".add_lookuplist");
		var errorMsgElement = form.find(".errmsg_pclookup");
		addressButton.turnLoadingOn();
		$.ajax({
			type: "GET",
			url: "/account/address-lookup",
			data: { postcode: postcode },
			dataType: "json",
			success: function (response) {
				addressButton.turnLoadingOff();

				if (response.success) {
					let addressList = response.data;
					errorMsgElement.addClass('hidden');
					$("option", $select_add).remove();
					$select_add.next('.select-styled').show();
					$select_add.append(
						$("<option></option>").attr("value", "").text("Select Address")
					);

					$.each(addressList["addresses"], function (key, value) {
						// format the address data
						var add_list = value.split(",").map(function (i) {
							return i === " " ? "" : i;
						});
						var formated_value = add_list
							.filter(function (i) {
								return i.length > 0;
							})
							.join(",");
						$select_add.append(
							$("<option></option>").attr("value", value).text(formated_value)
						);
					});

					$select_add.redrawSelect();

				} // end of property check
				else {
					$select_add.next('.select-styled').hide()
					errorMsgElement.text(
						"Your postcode could not be found. Please type in your address"
					);
					errorMsgElement.removeClass('hidden');
				}
			},
		});
	});

	$('body').on('change', '.add_lookuplist', function () {
		var address_val = $(this).val();
		var form = $(this).closest('form');
		if (address_val !== "") {
			var address_lines = address_val.split(",");
			// append to the fields
			var $address1 = form.find('input[name="addressLine1"]');
			var $address2 = form.find('input[name="addressLine2"]');
			var $address3 = form.find('input[name="addressLine3"]');
			var $address4 = form.find('input[name="addressLine4"]');

			// replace & sign with and
			$address1.val(address_lines[0].trim().replace("&", "and")).trigger("change");
			$address2.val("");
			$address3.val("");
			$address4.val("");
			if (!isEmptyOrSpaces(address_lines[1])) {
				$address2.val(address_lines[1].trim().replace("&", "and")).trigger("change");
			}
			if (!isEmptyOrSpaces(address_lines[2])) {
				$address3.val(address_lines[2].trim().replace("&", "and")).trigger("change");
			}
			if (!isEmptyOrSpaces(address_lines[3])) {
				$address4.val(address_lines[3].trim().replace("&", "and")).trigger("change");
			}

			form.find('input[name="city"]').val(address_lines[5]).trigger("change");

			if (address_lines.length >= 6 && !isEmptyOrSpaces(address_lines[6])) {
				form.find('input[name="county"]').val(address_lines[6]).trigger("change");
			}
		}
	});

	function isEmptyOrSpaces(str) {
		return str === null || str.match(/^ *$/) !== null;
	}
});
